// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.script.runtime.ObjectValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.IgnitorSlotLike
import io.peekandpoke.klang.script.stdlib.KatalystSlotLike
import io.peekandpoke.klang.sprudel.SprudelPattern
import io.peekandpoke.klang.sprudel.lang.PatternLike
import io.peekandpoke.klang.sprudel.lang.PatternMapperFn
import io.peekandpoke.klang.sprudel.lang.PatternMapperProvider
import io.peekandpoke.klang.sprudel.lang.abs
import io.peekandpoke.klang.sprudel.lang.accelerate
import io.peekandpoke.klang.sprudel.lang.add
import io.peekandpoke.klang.sprudel.lang.adsr
import io.peekandpoke.klang.sprudel.lang.adsrCurves
import io.peekandpoke.klang.sprudel.lang.adsrOff
import io.peekandpoke.klang.sprudel.lang.adsrOn
import io.peekandpoke.klang.sprudel.lang.almostAlways
import io.peekandpoke.klang.sprudel.lang.almostNever
import io.peekandpoke.klang.sprudel.lang.always
import io.peekandpoke.klang.sprudel.lang.analog
import io.peekandpoke.klang.sprudel.lang.and
import io.peekandpoke.klang.sprudel.lang.apply
import io.peekandpoke.klang.sprudel.lang.applyN
import io.peekandpoke.klang.sprudel.lang.arrange
import io.peekandpoke.klang.sprudel.lang.bandpass
import io.peekandpoke.klang.sprudel.lang.bank
import io.peekandpoke.klang.sprudel.lang.beatRate
import io.peekandpoke.klang.sprudel.lang.beats
import io.peekandpoke.klang.sprudel.lang.begin
import io.peekandpoke.klang.sprudel.lang.berlin
import io.peekandpoke.klang.sprudel.lang.binary
import io.peekandpoke.klang.sprudel.lang.binaryL
import io.peekandpoke.klang.sprudel.lang.binaryN
import io.peekandpoke.klang.sprudel.lang.binaryNL
import io.peekandpoke.klang.sprudel.lang.bitAnd
import io.peekandpoke.klang.sprudel.lang.bitOr
import io.peekandpoke.klang.sprudel.lang.bitShl
import io.peekandpoke.klang.sprudel.lang.bitShr
import io.peekandpoke.klang.sprudel.lang.bitXor
import io.peekandpoke.klang.sprudel.lang.bite
import io.peekandpoke.klang.sprudel.lang.bjork
import io.peekandpoke.klang.sprudel.lang.body
import io.peekandpoke.klang.sprudel.lang.bpf
import io.peekandpoke.klang.sprudel.lang.bpfCurves
import io.peekandpoke.klang.sprudel.lang.bpm
import io.peekandpoke.klang.sprudel.lang.brak
import io.peekandpoke.klang.sprudel.lang.brand
import io.peekandpoke.klang.sprudel.lang.brandBy
import io.peekandpoke.klang.sprudel.lang.bypass
import io.peekandpoke.klang.sprudel.lang.cat
import io.peekandpoke.klang.sprudel.lang.ceil
import io.peekandpoke.klang.sprudel.lang.choose
import io.peekandpoke.klang.sprudel.lang.chooseCycles
import io.peekandpoke.klang.sprudel.lang.chooseIn
import io.peekandpoke.klang.sprudel.lang.chooseInWith
import io.peekandpoke.klang.sprudel.lang.chooseOut
import io.peekandpoke.klang.sprudel.lang.chooseWith
import io.peekandpoke.klang.sprudel.lang.chord
import io.peekandpoke.klang.sprudel.lang.chunk
import io.peekandpoke.klang.sprudel.lang.chunkBack
import io.peekandpoke.klang.sprudel.lang.chunkBackInto
import io.peekandpoke.klang.sprudel.lang.chunkInto
import io.peekandpoke.klang.sprudel.lang.chunkback
import io.peekandpoke.klang.sprudel.lang.chunkbackinto
import io.peekandpoke.klang.sprudel.lang.chunkinto
import io.peekandpoke.klang.sprudel.lang.clamp
import io.peekandpoke.klang.sprudel.lang.clip
import io.peekandpoke.klang.sprudel.lang.coarse
import io.peekandpoke.klang.sprudel.lang.comp
import io.peekandpoke.klang.sprudel.lang.compress
import io.peekandpoke.klang.sprudel.lang.compressor
import io.peekandpoke.klang.sprudel.lang.cosine
import io.peekandpoke.klang.sprudel.lang.cps
import io.peekandpoke.klang.sprudel.lang.crush
import io.peekandpoke.klang.sprudel.lang.cull
import io.peekandpoke.klang.sprudel.lang.cut
import io.peekandpoke.klang.sprudel.lang.cylinder
import io.peekandpoke.klang.sprudel.lang.d
import io.peekandpoke.klang.sprudel.lang.degrade
import io.peekandpoke.klang.sprudel.lang.degradeBy
import io.peekandpoke.klang.sprudel.lang.degradeByWith
import io.peekandpoke.klang.sprudel.lang.delay
import io.peekandpoke.klang.sprudel.lang.density
import io.peekandpoke.klang.sprudel.lang.densityGap
import io.peekandpoke.klang.sprudel.lang.distort
import io.peekandpoke.klang.sprudel.lang.div
import io.peekandpoke.klang.sprudel.lang.drop
import io.peekandpoke.klang.sprudel.lang.duck
import io.peekandpoke.klang.sprudel.lang.duty
import io.peekandpoke.klang.sprudel.lang.early
import io.peekandpoke.klang.sprudel.lang.earlyInCycle
import io.peekandpoke.klang.sprudel.lang.echo
import io.peekandpoke.klang.sprudel.lang.echoWith
import io.peekandpoke.klang.sprudel.lang.echowith
import io.peekandpoke.klang.sprudel.lang.eish
import io.peekandpoke.klang.sprudel.lang.end
import io.peekandpoke.klang.sprudel.lang.eq
import io.peekandpoke.klang.sprudel.lang.eqt
import io.peekandpoke.klang.sprudel.lang.euclid
import io.peekandpoke.klang.sprudel.lang.euclidLegato
import io.peekandpoke.klang.sprudel.lang.euclidLegatoRot
import io.peekandpoke.klang.sprudel.lang.euclidRot
import io.peekandpoke.klang.sprudel.lang.euclidish
import io.peekandpoke.klang.sprudel.lang.euclidrot
import io.peekandpoke.klang.sprudel.lang.every
import io.peekandpoke.klang.sprudel.lang.extend
import io.peekandpoke.klang.sprudel.lang.fast
import io.peekandpoke.klang.sprudel.lang.fastChunk
import io.peekandpoke.klang.sprudel.lang.fastGap
import io.peekandpoke.klang.sprudel.lang.fastcat
import io.peekandpoke.klang.sprudel.lang.fastchunk
import io.peekandpoke.klang.sprudel.lang.filterWhen
import io.peekandpoke.klang.sprudel.lang.firstOf
import io.peekandpoke.klang.sprudel.lang.flipSign
import io.peekandpoke.klang.sprudel.lang.floor
import io.peekandpoke.klang.sprudel.lang.fm
import io.peekandpoke.klang.sprudel.lang.focus
import io.peekandpoke.klang.sprudel.lang.freq
import io.peekandpoke.klang.sprudel.lang.gain
import io.peekandpoke.klang.sprudel.lang.gap
import io.peekandpoke.klang.sprudel.lang.gt
import io.peekandpoke.klang.sprudel.lang.gte
import io.peekandpoke.klang.sprudel.lang.highpass
import io.peekandpoke.klang.sprudel.lang.hpf
import io.peekandpoke.klang.sprudel.lang.hpfCurves
import io.peekandpoke.klang.sprudel.lang.hurry
import io.peekandpoke.klang.sprudel.lang.hush
import io.peekandpoke.klang.sprudel.lang.ignitorParam
import io.peekandpoke.klang.sprudel.lang.ignp
import io.peekandpoke.klang.sprudel.lang.inhabit
import io.peekandpoke.klang.sprudel.lang.inhabitmod
import io.peekandpoke.klang.sprudel.lang.inside
import io.peekandpoke.klang.sprudel.lang.inv
import io.peekandpoke.klang.sprudel.lang.invert
import io.peekandpoke.klang.sprudel.lang.irand
import io.peekandpoke.klang.sprudel.lang.iter
import io.peekandpoke.klang.sprudel.lang.iterBack
import io.peekandpoke.klang.sprudel.lang.jux
import io.peekandpoke.klang.sprudel.lang.juxBy
import io.peekandpoke.klang.sprudel.lang.katalyst
import io.peekandpoke.klang.sprudel.lang.katalystParam
import io.peekandpoke.klang.sprudel.lang.katp
import io.peekandpoke.klang.sprudel.lang.lastOf
import io.peekandpoke.klang.sprudel.lang.late
import io.peekandpoke.klang.sprudel.lang.lateInCycle
import io.peekandpoke.klang.sprudel.lang.layer
import io.peekandpoke.klang.sprudel.lang.legato
import io.peekandpoke.klang.sprudel.lang.linger
import io.peekandpoke.klang.sprudel.lang.log2
import io.peekandpoke.klang.sprudel.lang.loop
import io.peekandpoke.klang.sprudel.lang.loopAt
import io.peekandpoke.klang.sprudel.lang.loopAtCps
import io.peekandpoke.klang.sprudel.lang.loopatcps
import io.peekandpoke.klang.sprudel.lang.lowpass
import io.peekandpoke.klang.sprudel.lang.lpf
import io.peekandpoke.klang.sprudel.lang.lpfCurves
import io.peekandpoke.klang.sprudel.lang.lt
import io.peekandpoke.klang.sprudel.lang.lte
import io.peekandpoke.klang.sprudel.lang.mask
import io.peekandpoke.klang.sprudel.lang.maskAll
import io.peekandpoke.klang.sprudel.lang.master
import io.peekandpoke.klang.sprudel.lang.max
import io.peekandpoke.klang.sprudel.lang.merge
import io.peekandpoke.klang.sprudel.lang.min
import io.peekandpoke.klang.sprudel.lang.mini
import io.peekandpoke.klang.sprudel.lang.mod
import io.peekandpoke.klang.sprudel.lang.morse
import io.peekandpoke.klang.sprudel.lang.mul
import io.peekandpoke.klang.sprudel.lang.mute
import io.peekandpoke.klang.sprudel.lang.n
import io.peekandpoke.klang.sprudel.lang.ne
import io.peekandpoke.klang.sprudel.lang.net
import io.peekandpoke.klang.sprudel.lang.never
import io.peekandpoke.klang.sprudel.lang.noCull
import io.peekandpoke.klang.sprudel.lang.not
import io.peekandpoke.klang.sprudel.lang.notch
import io.peekandpoke.klang.sprudel.lang.notchCurves
import io.peekandpoke.klang.sprudel.lang.note
import io.peekandpoke.klang.sprudel.lang.nothing
import io.peekandpoke.klang.sprudel.lang.o
import io.peekandpoke.klang.sprudel.lang.off
import io.peekandpoke.klang.sprudel.lang.often
import io.peekandpoke.klang.sprudel.lang.oneMinusValue
import io.peekandpoke.klang.sprudel.lang.onepole
import io.peekandpoke.klang.sprudel.lang.or
import io.peekandpoke.klang.sprudel.lang.orbit
import io.peekandpoke.klang.sprudel.lang.outside
import io.peekandpoke.klang.sprudel.lang.pace
import io.peekandpoke.klang.sprudel.lang.palindrome
import io.peekandpoke.klang.sprudel.lang.pan
import io.peekandpoke.klang.sprudel.lang.penv
import io.peekandpoke.klang.sprudel.lang.penvCurves
import io.peekandpoke.klang.sprudel.lang.perlin
import io.peekandpoke.klang.sprudel.lang.phaser
import io.peekandpoke.klang.sprudel.lang.pick
import io.peekandpoke.klang.sprudel.lang.pickF
import io.peekandpoke.klang.sprudel.lang.pickOut
import io.peekandpoke.klang.sprudel.lang.pickReset
import io.peekandpoke.klang.sprudel.lang.pickRestart
import io.peekandpoke.klang.sprudel.lang.pickSqueeze
import io.peekandpoke.klang.sprudel.lang.pickmod
import io.peekandpoke.klang.sprudel.lang.pickmodF
import io.peekandpoke.klang.sprudel.lang.pickmodOut
import io.peekandpoke.klang.sprudel.lang.pickmodReset
import io.peekandpoke.klang.sprudel.lang.pickmodRestart
import io.peekandpoke.klang.sprudel.lang.pickmodSqueeze
import io.peekandpoke.klang.sprudel.lang.ply
import io.peekandpoke.klang.sprudel.lang.plyForEach
import io.peekandpoke.klang.sprudel.lang.plyWith
import io.peekandpoke.klang.sprudel.lang.plyforeach
import io.peekandpoke.klang.sprudel.lang.plywith
import io.peekandpoke.klang.sprudel.lang.polymeter
import io.peekandpoke.klang.sprudel.lang.polymeterSteps
import io.peekandpoke.klang.sprudel.lang.polyrhythm
import io.peekandpoke.klang.sprudel.lang.pow
import io.peekandpoke.klang.sprudel.lang.pregain
import io.peekandpoke.klang.sprudel.lang.press
import io.peekandpoke.klang.sprudel.lang.pressBy
import io.peekandpoke.klang.sprudel.lang.pure
import io.peekandpoke.klang.sprudel.lang.rand
import io.peekandpoke.klang.sprudel.lang.randCycle
import io.peekandpoke.klang.sprudel.lang.randcat
import io.peekandpoke.klang.sprudel.lang.randrun
import io.peekandpoke.klang.sprudel.lang.range
import io.peekandpoke.klang.sprudel.lang.rangex
import io.peekandpoke.klang.sprudel.lang.rarely
import io.peekandpoke.klang.sprudel.lang.ratio
import io.peekandpoke.klang.sprudel.lang.repeat
import io.peekandpoke.klang.sprudel.lang.repeatCycles
import io.peekandpoke.klang.sprudel.lang.rest
import io.peekandpoke.klang.sprudel.lang.rev
import io.peekandpoke.klang.sprudel.lang.reverb
import io.peekandpoke.klang.sprudel.lang.revv
import io.peekandpoke.klang.sprudel.lang.rib
import io.peekandpoke.klang.sprudel.lang.ribbon
import io.peekandpoke.klang.sprudel.lang.rootNotes
import io.peekandpoke.klang.sprudel.lang.round
import io.peekandpoke.klang.sprudel.lang.rpm
import io.peekandpoke.klang.sprudel.lang.run
import io.peekandpoke.klang.sprudel.lang.s
import io.peekandpoke.klang.sprudel.lang.s_cat
import io.peekandpoke.klang.sprudel.lang.saw
import io.peekandpoke.klang.sprudel.lang.scale
import io.peekandpoke.klang.sprudel.lang.scaleTranspose
import io.peekandpoke.klang.sprudel.lang.scramble
import io.peekandpoke.klang.sprudel.lang.seed
import io.peekandpoke.klang.sprudel.lang.seg
import io.peekandpoke.klang.sprudel.lang.segment
import io.peekandpoke.klang.sprudel.lang.seq
import io.peekandpoke.klang.sprudel.lang.sequenceP
import io.peekandpoke.klang.sprudel.lang.shuffle
import io.peekandpoke.klang.sprudel.lang.signal
import io.peekandpoke.klang.sprudel.lang.silence
import io.peekandpoke.klang.sprudel.lang.sine
import io.peekandpoke.klang.sprudel.lang.sineOfDay
import io.peekandpoke.klang.sprudel.lang.sineOfNight
import io.peekandpoke.klang.sprudel.lang.slice
import io.peekandpoke.klang.sprudel.lang.slow
import io.peekandpoke.klang.sprudel.lang.slowChunk
import io.peekandpoke.klang.sprudel.lang.slowcat
import io.peekandpoke.klang.sprudel.lang.slowcatPrime
import io.peekandpoke.klang.sprudel.lang.slowchunk
import io.peekandpoke.klang.sprudel.lang.sndBrown
import io.peekandpoke.klang.sprudel.lang.sndCrackle
import io.peekandpoke.klang.sprudel.lang.sndDust
import io.peekandpoke.klang.sprudel.lang.sndNoise
import io.peekandpoke.klang.sprudel.lang.sndPink
import io.peekandpoke.klang.sprudel.lang.sndPluck
import io.peekandpoke.klang.sprudel.lang.sndPulze
import io.peekandpoke.klang.sprudel.lang.sndRamp
import io.peekandpoke.klang.sprudel.lang.sndSaw
import io.peekandpoke.klang.sprudel.lang.sndSine
import io.peekandpoke.klang.sprudel.lang.sndSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperPluck
import io.peekandpoke.klang.sprudel.lang.sndSuperRamp
import io.peekandpoke.klang.sprudel.lang.sndSuperSaw
import io.peekandpoke.klang.sprudel.lang.sndSuperSine
import io.peekandpoke.klang.sprudel.lang.sndSuperSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperTri
import io.peekandpoke.klang.sprudel.lang.sndTri
import io.peekandpoke.klang.sprudel.lang.sndZamp
import io.peekandpoke.klang.sprudel.lang.solo
import io.peekandpoke.klang.sprudel.lang.someCycles
import io.peekandpoke.klang.sprudel.lang.someCyclesBy
import io.peekandpoke.klang.sprudel.lang.sometimes
import io.peekandpoke.klang.sprudel.lang.sometimesBy
import io.peekandpoke.klang.sprudel.lang.sound
import io.peekandpoke.klang.sprudel.lang.speed
import io.peekandpoke.klang.sprudel.lang.splice
import io.peekandpoke.klang.sprudel.lang.square
import io.peekandpoke.klang.sprudel.lang.squeeze
import io.peekandpoke.klang.sprudel.lang.stack
import io.peekandpoke.klang.sprudel.lang.stackBy
import io.peekandpoke.klang.sprudel.lang.stackCentre
import io.peekandpoke.klang.sprudel.lang.stackLeft
import io.peekandpoke.klang.sprudel.lang.stackRight
import io.peekandpoke.klang.sprudel.lang.steady
import io.peekandpoke.klang.sprudel.lang.stepcat
import io.peekandpoke.klang.sprudel.lang.steps
import io.peekandpoke.klang.sprudel.lang.stretchBy
import io.peekandpoke.klang.sprudel.lang.struct
import io.peekandpoke.klang.sprudel.lang.structAll
import io.peekandpoke.klang.sprudel.lang.stut
import io.peekandpoke.klang.sprudel.lang.stutWith
import io.peekandpoke.klang.sprudel.lang.stutwith
import io.peekandpoke.klang.sprudel.lang.sub
import io.peekandpoke.klang.sprudel.lang.superimpose
import io.peekandpoke.klang.sprudel.lang.swing
import io.peekandpoke.klang.sprudel.lang.swingBy
import io.peekandpoke.klang.sprudel.lang.tag
import io.peekandpoke.klang.sprudel.lang.take
import io.peekandpoke.klang.sprudel.lang.time
import io.peekandpoke.klang.sprudel.lang.timeCat
import io.peekandpoke.klang.sprudel.lang.timeLoop
import io.peekandpoke.klang.sprudel.lang.timeOfDay
import io.peekandpoke.klang.sprudel.lang.timeOfNight
import io.peekandpoke.klang.sprudel.lang.timecat
import io.peekandpoke.klang.sprudel.lang.transpose
import io.peekandpoke.klang.sprudel.lang.tremolo
import io.peekandpoke.klang.sprudel.lang.tri
import io.peekandpoke.klang.sprudel.lang.tweak
import io.peekandpoke.klang.sprudel.lang.tweaks
import io.peekandpoke.klang.sprudel.lang.undegrade
import io.peekandpoke.klang.sprudel.lang.undegradeBy
import io.peekandpoke.klang.sprudel.lang.undegradeByWith
import io.peekandpoke.klang.sprudel.lang.uni
import io.peekandpoke.klang.sprudel.lang.unison
import io.peekandpoke.klang.sprudel.lang.unit
import io.peekandpoke.klang.sprudel.lang.vel
import io.peekandpoke.klang.sprudel.lang.velocity
import io.peekandpoke.klang.sprudel.lang.vib
import io.peekandpoke.klang.sprudel.lang.vibrato
import io.peekandpoke.klang.sprudel.lang.voicing
import io.peekandpoke.klang.sprudel.lang.vowel
import io.peekandpoke.klang.sprudel.lang.wchoose
import io.peekandpoke.klang.sprudel.lang.wchooseCycles
import io.peekandpoke.klang.sprudel.lang.`when`
import io.peekandpoke.klang.sprudel.lang.withSeed
import io.peekandpoke.klang.sprudel.lang.within
import io.peekandpoke.klang.sprudel.lang.wrandcat
import io.peekandpoke.klang.sprudel.lang.zoom
import kotlin.Function1

internal fun KlangScriptExtensionBuilder.registerSprudelLangEuclidChunk0() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "euclid",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclid", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclid", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclid", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclid(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "euclid",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclid", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclid", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclid", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclid(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @Function on euclid
    registerFunctionWithSpecs(
        name = "euclid",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "euclid", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclid", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclid", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(euclid(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "euclid",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclid", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclid", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclid", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclid(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "euclidRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "euclidRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @Function on euclidRot
    registerFunctionWithSpecs(
        name = "euclidRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "euclidRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(euclidRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "euclidRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "euclidrot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidrot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidrot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidrot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidrot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidrot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "euclidrot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidrot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidrot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidrot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidrot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidrot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @Function on euclidrot
    registerFunctionWithSpecs(
        name = "euclidrot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "euclidrot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidrot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidrot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidrot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(euclidrot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "euclidrot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidrot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidrot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidrot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidrot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidrot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "bjork",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bjork", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "bjork", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "bjork", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.bjork(
                pulses = pulses,
                steps = steps,
                rotation = if (args.size > 2) convertArgToKotlin(fn = "bjork", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int else 0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "bjork",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bjork", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "bjork", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "bjork", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.bjork(
                pulses = pulses,
                steps = steps,
                rotation = if (args.size > 2) convertArgToKotlin(fn = "bjork", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int else 0,
                callInfo = callInfo,
            )
        )
    }

    // @Function on bjork
    registerFunctionWithSpecs(
        name = "bjork",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(0) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "bjork", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "bjork", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "bjork", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            bjork(
                pulses = pulses,
                steps = steps,
                rotation = if (args.size > 2) convertArgToKotlin(fn = "bjork", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int else 0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "bjork",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bjork", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "bjork", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "bjork", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.bjork(
                pulses = pulses,
                steps = steps,
                rotation = if (args.size > 2) convertArgToKotlin(fn = "bjork", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int else 0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "euclidLegato",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidLegato", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegato", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegato", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidLegato(pulses = pulses, steps = steps, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangEuclidChunk1() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "euclidLegato",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidLegato", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegato", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegato", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidLegato(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @Function on euclidLegato
    registerFunctionWithSpecs(
        name = "euclidLegato",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "euclidLegato", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegato", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegato", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(euclidLegato(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "euclidLegato",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidLegato", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegato", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegato", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidLegato(pulses = pulses, steps = steps, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "euclidLegatoRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidLegatoRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidLegatoRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "euclidLegatoRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidLegatoRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidLegatoRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @Function on euclidLegatoRot
    registerFunctionWithSpecs(
        name = "euclidLegatoRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "euclidLegatoRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(euclidLegatoRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "euclidLegatoRot",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "rotation", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidLegatoRot", args = args, expected = 3, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        val rotation = convertArgToKotlin(fn = "euclidLegatoRot", args = args, index = 2, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.euclidLegatoRot(pulses = pulses, steps = steps, rotation = rotation, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "euclidish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.euclidish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "euclidish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "euclidish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.euclidish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "euclidish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @Function on euclidish
    registerFunctionWithSpecs(
        name = "euclidish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "euclidish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            euclidish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "euclidish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "euclidish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "euclidish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "euclidish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "euclidish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.euclidish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "euclidish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "eish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "eish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "eish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "eish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.eish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "eish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "eish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "eish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "eish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "eish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.eish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "eish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @Function on eish
    registerFunctionWithSpecs(
        name = "eish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "eish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "eish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "eish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            eish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "eish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "eish",
        paramSpecs = listOf(
            ParamSpec(name = "pulses", kotlinType = Int::class),
            ParamSpec(name = "steps", kotlinType = Int::class),
            ParamSpec(name = "groove", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "eish", args = args, expected = 2, location = loc)
        val pulses = convertArgToKotlin(fn = "eish", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val steps = convertArgToKotlin(fn = "eish", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            typedReceiver.eish(
                pulses = pulses,
                steps = steps,
                groove = if (args.size > 2) convertArgToKotlin(fn = "eish", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                callInfo = callInfo,
            )
        )
    }
}

